<script setup lang="ts">
import { QaEquipmentRtSystemDto } from '@/api/generator';
import PtwResetFilterButton from '@/components/buttons/PtwResetFilterButton.vue';
import SearchField from '@/components/filter/SearchField.vue';
import Autocomplete from '@/components/forms/Autocomplete/Autocomplete.vue';
import { getTranslatedOptions } from '@/utils/helper';
import { QaEquipmentAddFilterObject } from '@/views/qaEquipment/types.ts';
import { NO_BRAND } from '@/views/qaEquipment/utils.ts';
import { useTranslation } from 'i18next-vue';
import { uniq } from 'lodash';
import { computed } from 'vue';

const modelValue = defineModel<QaEquipmentAddFilterObject>({
  required: true,
});

interface QaEquipmentOverviewFilterProps {
  items: QaEquipmentRtSystemDto[];
}

const props = defineProps<QaEquipmentOverviewFilterProps>();

const subCategoryOptions = computed(() =>
  getTranslatedOptions(
    uniq(props.items.map((qaEquipment) => qaEquipment.subCategory)) ?? [],
    'QaEquipmentSubCategoryEnum',
  ),
);
const { t } = useTranslation();
const brandOptions = computed(() => [
  {
    title: t('NoBrand'),
    value: NO_BRAND,
  },
  ...getTranslatedOptions(
    uniq(
      props.items
        .map((qaEquipment) => qaEquipment.brand1?.toString())
        .filter((str: string | undefined | null): str is string => !!str),
    ) ?? [],
    'BrandEnum',
  ),
]);

function clearFilters() {
  modelValue.value = {};
}
</script>

<template>
  <v-row class="align-center mt-2 pl-2 pr-2">
    <v-col cols="12" sm="6" md="3" lg="3" class="pa-2">
      <SearchField v-model="modelValue.search" :placeholder="$t('Search')" />
    </v-col>
    <v-col cols="12" sm="6" md="3" lg="3" class="pa-2">
      <Autocomplete
        v-model="modelValue.brand1"
        :label="$t('Brand')"
        :items="brandOptions"
        :placeholder="$t('Brand')"
        multiple
        chips
        clearable
        emptyAsUndefined
      />
    </v-col>
    <v-col cols="12" sm="6" md="3" lg="3" class="pa-2">
      <Autocomplete
        v-model="modelValue.subCategory"
        :label="$t('Type_one')"
        :items="subCategoryOptions"
        :placeholder="$t('Type_one')"
        multiple
        clearable
        chips
        emptyAsUndefined
      ></Autocomplete>
    </v-col>
    <v-col md="3" lg="1" class="d-flex align-center justify-start pa-2">
      <PtwResetFilterButton @click="clearFilters" />
    </v-col>
  </v-row>
</template>
